/* eslint-disable */
import * as React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { connect } from 'react-redux'
import FlexBox from '../common/FlexBox'
import Select from '../common/Select'
import ZIndexScale from '../../utils/zIndexScale'

import { withI18n } from '../../i18n/util'

const Wrap = styled(FlexBox)`
  align-items: 'center';
  padding: 0 10px;
  line-height: 30px;
`

const BaseCoinWrap = styled.div`
  position: relative;
  z-index: ${() => ZIndexScale.normalZIndex};
`

const SearchList = styled.ul`
  position: absolute;
  max-height: 150px;
  width: 150%;
  box-shadow: ${({ theme }) => theme.boxShadow};
  overflow: auto;
  background: ${({ theme }) => theme.dropdownBg};
  li {
    padding: 0 5px;
    cursor: pointer;
    &:hover {
      background: ${({ theme }) => theme.dropdownSelectBgColor};
      color: #f0b90b;
    }
  }
`

const BaseCoin = styled.input`
  height: 22px;
  line-height: 22px;
  width: 80px;
  outline: none;
  border: none;
  border-bottom: 1px solid #dfe2e7;
  text-indent: 5px;
  color: #48515d;
  ${({ theme }) =>
    theme.mode === 'DARK'
      ? `
    border-bottom: none;
    background: #252D38;
    color: #848E9C;
    border-radius: 3px;
    height: 20px;
    `
      : ''}
`

const QuotaCoin = styled.div`
  height: 30px;
  line-height: 30px;
  width: 80px;
  outline: none;
  border: none;
  text-indent: 5px;
  color: #48515d;
  .select {
    height: 27px;
    line-height: 27px;
  }
`

const Slash = styled.span`
  font-size: 16px;
  margin: 0 5px;
`

class OrderHistoryFilter extends React.Component {
  static propTypes = {
    onChange: PropTypes.func,
    pairs: PropTypes.array.isRequired,
    tokens: PropTypes.array.isRequired,
  }

  static defaultProps = {
    onChange: () => {},
  }

  _node = React.createRef()

  constructor(props) {
    super(props)
    const quoteAssets = this._buildCoinOptions() || [{}]
    this.state = {
      baseAsset: '',
      quoteAsset: quoteAssets[0] && quoteAssets[0].value,
      searchList: [],
    }
  }

  componentDidMount() {
    window.document.body.addEventListener('click', this._clickBody)
  }

  componentDidUpdate(prevProps) {
    const { pairs } = this.props
    if (pairs.length > 0 && prevProps.pairs.length === 0) {
      const quoteAssets = this._buildCoinOptions()
      this.setState({ quoteAsset: quoteAssets[0].value })
    }
  }

  componentWillUnmount() {
    window.document.body.removeEventListener('click', this._clickBody)
  }

  _clickBody = evt => {
    if (this._node.current && !this._node.current.contains(evt.target)) {
      this.setState({ searchList: [] })
    }
  }

  _buildCoinOptions = () => {
    const { pairs } = this.props
    const result = []

    pairs.forEach(pair => {
      const quoteSymbol = result.find(symbol => symbol === pair.quote_asset_symbol)
      if (!quoteSymbol) {
        result.push(pair.quote_asset_symbol)
      }
    })

    return result.map(symbol => ({
      value: symbol,
      text: symbol.replace(/-.*$/i, ''),
    }))
  }

  _selectCoin = coin => {
    const { quoteAsset } = this.state
    const { onChange } = this.props
    this.setState({ baseAsset: coin.symbol, searchList: [] })
    onChange(coin.symbol, quoteAsset)
  }

  _buildSearchOptions = () => {
    const { searchList } = this.state
    return searchList.map((coin, index) => (
      <li
        key={index}
        onClick={() => {
          this._selectCoin(coin)
        }}
      >
        {coin.symbol}
      </li>
    ))
  }

  _baseCoinChange = e => {
    let {
      target: { value },
      type,
    } = e
    value = value.trim().toUpperCase()
    const { tokens } = this.props
    const searchList = value
      ? tokens.filter(token => token.original_symbol.toUpperCase().includes(value))
      : []
    const newState = { searchList }
    if (type === 'change') {
      newState.baseAsset = value
    }
    this.setState(newState)

    if (!value) {
      const { onChange } = this.props
      onChange('')
    }
  }

  _quoteCoinChange = quoteAsset => {
    const { onChange } = this.props
    const { baseAsset } = this.state
    this.setState({ quoteAsset })
    onChange(baseAsset, quoteAsset)
  }

  render() {
    const { baseAsset } = this.state
    const { formatI18nText } = this.props
    const coinOptions = this._buildCoinOptions()
    const searchOpts = this._buildSearchOptions()

    return (
      <Wrap ref={this._node}>
        <div>{formatI18nText('exchange.pair')}:</div>
        &nbsp;&nbsp;
        <BaseCoinWrap>
          <BaseCoin
            placeholder={formatI18nText('exchange.coin')}
            value={baseAsset.replace(/-.*$/i, '')}
            onChange={this._baseCoinChange}
            onFocus={this._baseCoinChange}
          />
          {searchOpts.length > 0 && <SearchList>{searchOpts}</SearchList>}
        </BaseCoinWrap>
        <Slash>/</Slash>
        <QuotaCoin>{<Select options={coinOptions} onChange={this._quoteCoinChange} />}</QuotaCoin>
      </Wrap>
    )
  }
}

const mapStateToProps = ({ exchange: { tokens }, tradePairs: { pairs } }) => ({
  pairs,
  tokens,
})

export default withI18n(connect(mapStateToProps)(OrderHistoryFilter))
